"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LOADED = Symbol("loaded");
var LOADED_RESOLVE = Symbol("loadedResolve");
var LOADED_REJECT = Symbol("loadedReject");

var STARTED = Symbol("started");
var STARTED_RESOLVE = Symbol("startedResolve");
var STARTED_REJECT = Symbol("startedReject");

var ENDED = Symbol("ended");
var ENDED_RESOLVE = Symbol("endedResolve");
var ENDED_REJECT = Symbol("endedReject");

/**
* GameModel class
* @class
* @classdesc
*
* This class is for encapsulating the current game state/config
*
* Access the game data on the game instance itself, eg) gameModel.jToken
*
* Hook into lifetime events from the promises, onLoaded, onStarted, onEnded
*
* Each of the promises return the api response for that event
*
* @example
*   gameManager.gameModel.onStarted.then((startResponse) => {
*       // start succeeded, resp is GameServiceResponse 
*   }).catch((err) => {
*       // start failed, err is GameServiceError
*   });
*
* @param {GameJSON} gameJson
*/

var GameModel = function () {
    function GameModel(gameJson) {
        var _this = this;

        _classCallCheck(this, GameModel);

        (0, _utils.objectAssign)(this, gameJson);
        this._onLoaded = new Promise(function (resolve, reject) {
            _this[LOADED_RESOLVE] = resolve;
            _this[LOADED_REJECT] = reject;
        });
        this._onStarted = new Promise(function (resolve, reject) {
            _this[STARTED_RESOLVE] = resolve;
            _this[STARTED_REJECT] = reject;
        });
        this._onEnded = new Promise(function (resolve, reject) {
            _this[ENDED_RESOLVE] = resolve;
            _this[ENDED_REJECT] = reject;
        });
    }

    /**
    * Whether or not this game represents a flash game
    * @member {bool}
    */


    _createClass(GameModel, [{
        key: "setLoadedResponse",


        /**
        * Set the loaded response. Call once only. Called by GameManager
        *
        * @param {GameServiceError} [err] - error Failed response, will reject the onLoaded promise
        * @param {GameServiceResponse} [resp] - Loaded response if any, will resolve the onLoaded promise
        */
        value: function setLoadedResponse(err, resp) {
            if (this[LOADED] !== undefined) {
                console.log("loaded already set");
                return;
            }
            if (err) {
                this.errorResponse = err;
                this[LOADED] = false;
                this[LOADED_REJECT](err);
            } else {
                this.loadedResponse = resp;
                this[LOADED] = true;
                this[LOADED_RESOLVE](resp);
            }
        }

        /**
        * Whether the game has been started
        * @member {bool}
        */

    }, {
        key: "setStartedResponse",


        /**
        * Set the start response. Call once only. Called by GameManager
        *
        * @param {GameServiceError} err - Failed response, will reject the onStarted promise
        * @param {GameServiceResponse} startResponse - start response, will resolve the onStarted promise
        */
        value: function setStartedResponse(err, startResponse) {
            if (this[STARTED] !== undefined) {
                console.log("started already set");
                return;
            }
            if (err) {
                this.errorResponse = err;
                this[STARTED] = false;
                this[STARTED_REJECT](err);
            } else {
                this.startResponse = startResponse;
                this[STARTED] = true;
                this[STARTED_RESOLVE](startResponse);
            }
        }

        /**
        * Whether the game has ended
        * @member {bool}
        */

    }, {
        key: "setEndedResponse",


        /**
        * Set the end response. Call once only. Called by GameManager
        *
        * @param {GameServiceError} err - Failed response, will reject the onEnded promise
        * @param {GameServiceResponse} endResponse - end response, will resolve the onEnded promise
        */
        value: function setEndedResponse(err, endResponse) {
            if (this[ENDED] !== undefined) {
                console.log("ended already set");
                return;
            }
            if (err) {
                this[ENDED] = false;
                this.errorResponse = err;
                this[ENDED_REJECT](err);
            } else {
                this[ENDED] = true;
                this.endResponse = endResponse;
                this[ENDED_RESOLVE](endResponse);
            }
        }

        /**
        * The error response from this game, if any
        * @member {GameServiceError|null}
        */

    }, {
        key: "getServiceData",


        /**
        * Get the service data block
        * @returns {object}
        */
        value: function getServiceData() {
            return this.service && this.service.data || null;
        }

        /**
        * Get the return url
        * @returns {string}
        */

    }, {
        key: "getReturnUrl",
        value: function getReturnUrl() {
            return this.returnURL || this.service.data && this.service.data.returnURL || "/";
        }

        /**
        * Get the game id
        * @returns {string|number}
        */

    }, {
        key: "getGameId",
        value: function getGameId() {
            return this.game && this.game.id || this.getItemId();
        }

        /**
        * Get the game description
        * @returns {string}
        */

    }, {
        key: "getGamePlayDesc",
        value: function getGamePlayDesc() {
            return this.game && this.game.playDesc || "";
        }

        /**
         * Get the game url (applicable for iframe games)
         * @returns {string}
         */

    }, {
        key: "getGameUrl",
        value: function getGameUrl() {
            return this.game && this.game.url || "";
        }

        /**
        * Get the item id
        * @returns {string|number}
        */

    }, {
        key: "getItemId",
        value: function getItemId() {
            return this.item && this.item.id || this.itemId;
        }

        /**
        * Get the path id
        * @returns {string|number}
        */

    }, {
        key: "getPathId",
        value: function getPathId() {
            return this.path && this.path.path_id || this.pathId;
        }

        /**
        * Get the device type value
        * @returns {string}
        */

    }, {
        key: "getDevice",
        value: function getDevice() {
            return this.device || "desktop";
        }

        /**
        * Get app code
        * @returns {string}
        */

    }, {
        key: "getAppCode",
        value: function getAppCode() {
            return this.appCode;
        }

        /**
        * Get user email
        * @returns {string}
        */

    }, {
        key: "getUserEmail",
        value: function getUserEmail() {
            return this.user && this.user.email || this.email;
        }

        /**
        * Get user gmt
        * @returns {string}
        */

    }, {
        key: "getUserGmt",
        value: function getUserGmt() {
            return this.user && this.user.gmt || this.gmt;
        }

        /**
        * Get security token
        * @returns {string}
        */

    }, {
        key: "getSecurityToken",
        value: function getSecurityToken() {
            return this.security_token || this.jToken;
        }

        /**
        * Update the security token for this instance from the given service response
        * @param {GameServiceResponse}
        */

    }, {
        key: "updateSecurityTokenFromResponse",
        value: function updateSecurityTokenFromResponse(resp) {
            if (!resp || !resp.body) {
                return;
            }
            this.jToken = resp.body.jToken || resp.body.jtoken || null;
            this.security_token = resp.body.security_token || resp.body.data && resp.body.data.security_token || this.jToken || this.security_token;
        }

        /**
         * @return bool
         */

    }, {
        key: "isIframeGame",
        value: function isIframeGame() {
            return (this.game || this.item || {}).package_type === 'v3';
        }
    }, {
        key: "isFlashGame",
        get: function get() {
            return this.type === "SWF";
        }

        /**
        * Whether or not this game has been loaded yet
        * @member {bool}
        */

    }, {
        key: "hasLoaded",
        get: function get() {
            return this[LOADED] === true;
        }

        /**
        * Promise for onLoaded
        *
        * @member {Promise}
        * @example
        *   gameModel.onLoaded
        *            .then(() => { console.log("loaded"); })
        *            .catch(() => { console.log("load failed"); });
        */

    }, {
        key: "onLoaded",
        get: function get() {
            return this._onLoaded;
        }
    }, {
        key: "hasStarted",
        get: function get() {
            return this[STARTED] === true;
        }

        /**
        * Promise for onStarted. 
        * Passes the api response in the callbacks (GameServiceResponse or GameServiceError)
        *
        * @example
        *   gameModel.onStarted
        *            .then((startResponse) => { console.log("started"); })
        *            .catch((errResponse) => { console.log("start failed"); });
        *
        * @member {Promise<GameServiceResponse>}
        */

    }, {
        key: "onStarted",
        get: function get() {
            return this._onStarted;
        }
    }, {
        key: "hasEnded",
        get: function get() {
            return this[ENDED] === true;
        }

        /**
        * Promise for onEnded. 
        * Passes the api response in the callbacks (GameServiceResponse or GameServiceError)
        *
        * @example
        *   gameModel.onEnded
        *            .then((endResponse) => { console.log("ended"); })
        *            .catch((errResponse) => { console.log("ended failed"); });
        *
        * @member {Promise<GameServiceResponse>}
        */

    }, {
        key: "onEnded",
        get: function get() {
            return this._onEnded;
        }
    }, {
        key: "errorResponse",
        get: function get() {
            return this._errorResponse;
        },
        set: function set(resp) {
            this._errorResponse = resp;
            this.errorMessage = resp.body;
        }

        /**
        * Whether the game has an error response
        * @member {bool}
        */

    }, {
        key: "hasErrored",
        get: function get() {
            if (this.errorResponse) {
                return true;
            }
            return typeof this.errorMessage === 'string' && this.errorMessage.length > 0;
        }
    }]);

    return GameModel;
}();

exports.default = GameModel;